if (!customElements.get("m-objective-slider")) {
  class MObjectiveSlider extends HTMLElement {
    connectedCallback() {
      const slideContainer = this.querySelector(".swiper-container");
      if (!slideContainer) return;

      this.slider = new MinimogLibs.Swiper(slideContainer, {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: parseInt(this.dataset.gapMobile || "14", 10),
        loop: false,
        centeredSlides: false,
        watchOverflow: true,
        navigation: {
          nextEl: this.querySelector(".swiper-button-next"),
          prevEl: this.querySelector(".swiper-button-prev"),
        },
        breakpoints: {
          768: {
            slidesPerView: 3,
            centeredSlides: false,
            spaceBetween: parseInt(this.dataset.gap || "24", 10),
          },
          1024: {
            slidesPerView: 4,
            centeredSlides: false,
            spaceBetween: parseInt(this.dataset.gap || "24", 10),
          },
        },
      });
    }
  }

  customElements.define("m-objective-slider", MObjectiveSlider);
}
